export const GMAIL_TOOLKIT = 'gmail';
export const CALENDAR_TOOLKIT = 'googlecalendar';

export const MORE_APPS = [
  { toolkitName: 'outlook', name: 'Outlook' },
  { toolkitName: 'googledrive', name: 'Google Drive' },
  {
    toolkitName: 'slack',
    name: 'Slack',
    url: 'https://mcp.slack.com/mcp',
  },
  {
    toolkitName: 'notion',
    name: 'Notion',
    url: 'https://mcp.notion.com/mcp',
  },
  {
    toolkitName: 'todoist',
    name: 'Todoist',
    url: 'https://ai.todoist.net/mcp',
  },
  {
    toolkitName: 'github',
    name: 'GitHub',
    url: 'https://api.githubcopilot.com/mcp/',
  },
  { toolkitName: 'googlesheets', name: 'Google Sheets' },
  { toolkitName: 'googledocs', name: 'Google Docs' },
];

export const DEMO_SOURCES = [
  {
    toolkitName: GMAIL_TOOLKIT,
    name: 'Gmail',
    cards: [
      { metaWidth: '38%', titleWidth: '78%' },
      { metaWidth: '30%', titleWidth: '64%' },
    ],
  },
  {
    toolkitName: CALENDAR_TOOLKIT,
    name: 'Calendar',
    cards: [{ metaWidth: '44%', titleWidth: '70%' }],
  },
  {
    toolkitName: 'googledrive',
    name: 'Drive',
    cards: [{ metaWidth: '34%', titleWidth: '86%' }],
  },
];

export const PREPARE_STEPS = [
  'Reading connected apps',
  'Prioritizing',
  'Arranging feed',
];

export const PREPARE_DURATION_MS = 4000;
